export function hitShapeIdAtClientPoint(clientX: number, clientY: number): string | null {
  const topEl = document.elementFromPoint(clientX, clientY)
  const host = topEl instanceof HTMLElement ? topEl.closest('[data-shape-id]') : null

  return host instanceof HTMLElement ? host.getAttribute('data-shape-id') : null
}
